var map = {
	"./af.json": 842,
	"./am.json": 843,
	"./ar.json": 844,
	"./az.json": 845,
	"./be.json": 846,
	"./bg.json": 847,
	"./bn.json": 848,
	"./bs.json": 849,
	"./ca.json": 850,
	"./cs.json": 851,
	"./cy.json": 852,
	"./da.json": 853,
	"./de.json": 854,
	"./dv.json": 855,
	"./el.json": 856,
	"./en.json": 857,
	"./es.json": 858,
	"./et.json": 859,
	"./eu.json": 860,
	"./fa.json": 861,
	"./fi.json": 862,
	"./fr.json": 863,
	"./gl.json": 864,
	"./ha.json": 865,
	"./he.json": 866,
	"./hi.json": 867,
	"./hr.json": 868,
	"./hu.json": 869,
	"./hy.json": 870,
	"./id.json": 871,
	"./is.json": 872,
	"./it.json": 873,
	"./ja.json": 874,
	"./ka.json": 875,
	"./kk.json": 876,
	"./km.json": 877,
	"./ko.json": 878,
	"./ku.json": 879,
	"./ky.json": 880,
	"./lt.json": 881,
	"./lv.json": 882,
	"./mk.json": 883,
	"./ml.json": 884,
	"./mn.json": 885,
	"./ms.json": 886,
	"./nb.json": 887,
	"./nl.json": 888,
	"./nn.json": 889,
	"./no.json": 890,
	"./pl.json": 891,
	"./ps.json": 892,
	"./pt.json": 893,
	"./ro.json": 894,
	"./ru.json": 895,
	"./sd.json": 896,
	"./sk.json": 897,
	"./sl.json": 898,
	"./so.json": 899,
	"./sq.json": 900,
	"./sr.json": 901,
	"./sv.json": 902,
	"./sw.json": 903,
	"./ta.json": 904,
	"./tg.json": 905,
	"./th.json": 906,
	"./tr.json": 907,
	"./tt.json": 908,
	"./ug.json": 909,
	"./uk.json": 910,
	"./ur.json": 911,
	"./uz.json": 912,
	"./vi.json": 913,
	"./zh.json": 914
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 841;